import styled from 'styled-components/macro';

export const ChartWrapper = styled.div`
  padding: 32px 32px;
  position: relative;
  box-sizing: border-box;
`;

export const DateWrapper = styled.div`
  text-align: right;
  padding-right: 24px;
`;

export const TimePlaceWrapper = styled.div`
  padding-left: 24px;
`;
